import { getCustomerId } from 'redux/modules/sessions/selectors';
import { getInterstitialsSteps } from 'redux/modules/interstitials/selectors';

export default state => ({
  event: 'checkout_interstitials_navigation',
  interstitials: getInterstitialsSteps(state),
  customerId: getCustomerId(state),
});
